import React from 'react';

export default function ManifestoSection() {
  return (
    <section className="manifesto-section">
      {/* Notebook margin line */}
      <div className="notebook-margin" />

      {/* Scribbled header */}
      <div className="manifesto-header">
        <svg viewBox="0 0 300 50" width="280" height="45">
          <text
            x="150"
            y="35"
            textAnchor="middle"
            fontFamily="'Permanent Marker', cursive"
            fontSize="32"
            fill="#1a1a1a"
            transform="rotate(-1.5, 150, 35)"
          >
            THE MANIFESTO
          </text>
          {/* Messy underline */}
          <path
            d="M 20,42 Q 80,48 150,40 Q 220,34 280,44"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className="manifesto-body">
        <p className="manifesto-text">
          back then you saw a stupid drawing and bought it
        </p>
        <p className="manifesto-text">
          no roadmap no ai no nonsense
        </p>
        <p className="manifesto-text manifesto-emphasis">
          just vibes
        </p>
        <p className="manifesto-text">
          we are going back
        </p>

        {/* Scribbled annotation */}
        <div className="manifesto-annotation" style={{ transform: 'rotate(3deg)', marginTop: '30px' }}>
          <svg viewBox="0 0 200 40" width="180" height="36">
            <rect x="5" y="5" width="190" height="30" rx="2" fill="none" stroke="#1a1a1a" strokeWidth="1.5" strokeDasharray="6 3" />
            <text x="100" y="26" textAnchor="middle" fontFamily="'Caveat', cursive" fontSize="18" fill="#1a1a1a">
              ^ this is probably bullish
            </text>
          </svg>
        </div>
      </div>

      {/* Extra messy details */}
      <div className="manifesto-extras">
        <p className="manifesto-note" style={{ transform: 'rotate(-2deg)' }}>
          we have no idea what we're doing
        </p>
        <p className="manifesto-note" style={{ transform: 'rotate(1.5deg)', marginTop: '8px' }}>
          and that's exactly the point
        </p>
      </div>

      {/* Hand-drawn divider */}
      <svg className="section-divider" viewBox="0 0 600 20" width="100%" height="20">
        <path
          d="M 0,10 Q 75,2 150,12 Q 225,20 300,8 Q 375,0 450,14 Q 525,22 600,10"
          fill="none"
          stroke="#1a1a1a"
          strokeWidth="2"
          strokeLinecap="round"
          opacity="0.3"
        />
      </svg>
    </section>
  );
}
